import { defineStore } from 'pinia';
import { getInitialEntityState } from '@/store/common/entities-state';
import { createEntityActions } from '@/store/common/entities-actions';
import { Collection } from '@/store/common/collections';
import { createEntityGetters } from '@/store/common/entities-getters';
import { Category } from '@/model/category';
import { InputOption } from '@/model/input-option';
import { reactive } from 'vue';
import i18n from '@/config/i18n';

const initialEntityState = reactive({
  ...getInitialEntityState<Category>(),
});

export const useCategoriesStore = defineStore('categories', {
  state: () => {
    return initialEntityState;
  },
  getters: {
    ...createEntityGetters<Category>(),
    getAsSelectOptions(): InputOption[] {
      return this.entities.map((category) => {
        return {
          value: category.id + '',
          label: category._translations[i18n.global.locale.value].name,
        };
      });
    },
  },
  actions: {
    ...createEntityActions<Category>(Collection.CATEGORIES, initialEntityState),
  },
});
